

























































import { Vue, Component, Prop } from 'vue-property-decorator'
import { CostListMap } from '@/types/newPersion'
import {
  getCostList,
} from '../../../utils'
import FormItem from '@/components/formItem/index.vue'
import DoalogSlot from '@/components/dialog/doalogSlot.vue'

@Component({
  components: { FormItem, DoalogSlot },
})
export default class PersionCalculatorDialog extends Vue {
    @Prop() dialogShow!: boolean

      optionsList: CostListMap[] = [];
      optionsObj: CostListMap | null = null

    money = '';
    value = ''
    defaultKey = {
      label: 'level',
      value: 'id',
      key: 'id'
    }

    created () {
      this.getCostListData()
    }

    async getCostListData () {
      this.optionsList = await getCostList()
    }

    private handleConfirm () {
      if (this.money) {
        this.$emit('on-handle-confirm', this.money)
        this.handleEmpty()
      } else {
        this.$message({
          type: 'error',
          message: '请选择养老费用，或者点击取消退出养老生活计算器'
        })
      }
    }

    private handleChange (id: string) {
      this.optionsObj = this.optionsList.find((item: CostListMap) => item.id === id) || null
    }

    private selectMoney (money: string) {
      this.money = money
      this.handleConfirm()
    }

    private handleClose () {
      this.handleEmpty()
      this.$emit('on-handle-close')
    }

    private handleEmpty () {
      this.money = this.value = ''
      this.optionsObj = null
    }
}
